import { DutyActivity, Trip } from '../../models/workday';

class BlockPrep {
  vehicleInfo: string;
  intro: string;
  information: string;

  constructor(vehicleInfo: string, intro: string, information: string) {
    this.vehicleInfo = vehicleInfo;
    this.intro = intro;
    this.information = information;
  }
}

export const createBlockPrep = (
  da: DutyActivity,
  isOutPrep: boolean,
): BlockPrep => {
  return isOutPrep
    ? new BlockPrep(
      getVehicleInfoText(da, da.Trip[0]),
      getFromIntroText(da, da.Trip[0]),
      getFromInformationText(da, da.Trip[0]),
    )
    : new BlockPrep(
      getVehicleInfoText(da, da.Trip.slice(-1)[0]),
      getToIntroText(da.Trip.slice(-1)[0]),
      getToInformationText(da, da.Trip.slice(-1)[0]),
    );
};

function getVehicleInfoText(da: DutyActivity, trip: Trip) {
  if (trip.BlkPrepOut !== '' && da.DtyActCostId === 0) {
    return 'Klargöring av fordon klockan ' + trip.BlkPrepOut;
  }
  if (trip.BlkPrepIn !== '' && da.DtyActCostId === 0) {
    return 'Avställning av fordon klockan ' + trip.BlkPrepIn;
  }
  return '';
}

function getFromIntroText(da: DutyActivity, trip: Trip) {
  if (trip.TrpRouteTransdevSpecial === 'Avlösningsbil') {
    return trip.TrpRouteTransdevSpecial;
  }
  if (trip.TrpType === 1) {
    if (da.DtyActCostId !== 0) {
      if (trip.TrpVehicle === '') {
        return 'Åk med utgående fordon omlopp ' + trip.TrpBlock;
      } else {
        return (
          'Åk med utgående fordon ' +
          trip.TrpVehicle +
          ', omlopp ' +
          trip.TrpBlock
        );
      }
    }
  }
  if (trip.TrpType === 2) {
    if (da.DtyActCostId === 0) {
      return 'Inkörning till depån';
    } else {
      return 'Åk med ingående fordon omlopp ' + trip.TrpBlock;
    }
  }
  return '';
}

function getFromInformationText(da: DutyActivity, trip: Trip) {
  if (
    da.DtyActStartPlace !== trip.TrpPlaceStart &&
    da.DtyActStartPlace !== trip.TrpPlaceStartDesc &&
    da.DtyActCostId === 0
  ) {
    if (trip.TrpServiceMode === 'TRAM') {
      return 'Spårvagnen kommer från ' + trip.TrpPlaceStartDesc;
    }
    return 'Bussen kommer från ' + trip.TrpPlaceStartDesc;
  }
  return '';
}

function getToIntroText(trip: Trip) {
  if (trip.TrpNextRoute) {
    if (trip.TrpNextRoute === 'Tomkör') {
      return (
        'Nästa avgång: Tomkör mot ' +
        trip.TrpNextPlaceEndDesc +
        ' kl. ' +
        trip.TrpNextStartTime
      );
    }
    if (trip.TrpNextRoute === 'Inkörn') {
      return 'Nästa avgång: Kör in i depån kl. ' + trip.TrpNextStartTime;
    }
    return (
      'Nästa avgång: linje ' +
      trip.TrpNextRoute +
      ' mot ' +
      trip.TrpNextPlaceEndDesc +
      ' kl. ' +
      trip.TrpNextStartTime
    );
  }
  return '';
}

function getToInformationText(da: DutyActivity, trip: Trip) {
  if (
    da.DtyActEndPlace !== trip.TrpPlaceEnd &&
    da.DtyActEndPlace !== trip.TrpPlaceEndDesc &&
    da.DtyActCostId === 0
  ) {
    if (trip.TrpServiceMode === 'TRAM') {
      return (
        'Spårvagnen fortsätter till ' +
        trip.TrpPlaceEndDesc +
        ' ank. ' +
        trip.TrpTimeEnd
      );
    }
    return (
      'Bussen fortsätter till ' +
      trip.TrpPlaceEndDesc +
      ' ank. ' +
      trip.TrpTimeEnd
    );
  }
  return '';
}
